import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'
import Question from '@/components/historyQuestion/historyQuestion'

@Component({
  components: {
    Question
  }
})
export default class HistoryEvaluation extends Vue {
  @Prop({ default: '' }) modalType!: String
  @Prop({ default: () => [] }) answers!: Array<any>
  @Prop({ default: () => {} }) close!: Function

  @Action action_getQuestionOrder: any
  @Action action_postAnswers: any

  @Getter getCurrentOrder: any
  @Getter getAnswers: any
  @Getter getDeliveryMan: any
  @Getter getQuestionOrder: any

  @Mutation RATED: any

  questions = []
  isServiceQuestion = false
  allAnswers = []

  mounted() {
    this.action_getQuestionOrder()
  }

  calcualteAnswer(question: any) {
    const response = this.answers.find((element: any) => {
      return element.type === question.question
    })
    if (response) {
      return { isAnswered: true, answer: response.answer }
    } else {
      return { isAnswered: false, answer: '' }
    }
  }

  async sendAnswer(type: any, id: any, questionType: any) {
    try {
      const data = {
        answer: {
          question_id: id,
          answer: type
        }
      }
      this.close()
      const res = this.action_postAnswers(data)
      if (questionType === 'comments') {
        this.$swal({
          imageUrl: '/assets/images/ui/cohete.png',
          imageWidth: 100,
          title: 'Gracias, tus comentarios nos ayudan a mejorar!',
          showConfirmButton: false,
          timer: 1500
        })
      }
    } catch (error) {
      const status = error && error.response && error.response.status
      if (status >= 500) {
        this.$swal({
          title: 'Error al calificar...',
          text: `Problemas con el servidor. Error ${status}`
        })
//        let message = 'Ayuda! \nMe está saliendo un error con el servidor.';
//        (window as any).Intercom('showNewMessage', message)
      } else {
        this.$swal({
          title: 'Error al calificar...',
          text: error.response.data.message
        })
      }
    }
  }

  setShow(question: any) {
    switch (question.question) {
      case 'Service':
        if (this.getCurrentOrder.is_takeout) {
          return ''
        } else {
          return this.getDeliveryMan
        }
      case 'Order':
        return this.getCurrentOrder.commerce.commercial_name
      case 'comments':
        return '¿Qué mejorarías de toda la experiencia?'
      default:
        break
    }
  }

  setLogo(question: any) {
    switch (question.question) {
      case 'Service':
        return 'not logo'
      case 'Order':
        return this.getCurrentOrder.logo
      default:
        break
    }
  }

  setIsService(question: any) {
    switch (question.question) {
      case 'Service':
        return true
      case 'Order':
        return false
      default:
        break
    }
  }

  setAnswers(text: any, id: any, type: any) {
    let beforeAnswers = []
    beforeAnswers = this.allAnswers.filter((answer) => {
      return answer && answer.id !== id
    })
    beforeAnswers.push({
      id,
      answer: text,
      type
    })
    this.allAnswers = beforeAnswers
  }
}
